import api from './StreamsAPI';
import fixUrls from '../fixUrls.js';

export default {
    getStream: ({id, name}) => {
        const h=id+'/'+name;
        const m_api = api();
        console.log(`getStream: getting '${h}'`);
        return m_api
        .get(h)
        .then(response => {
            console.log(`getStream: got '${h}'`); 
            return response; 
        });
    },
    getContent: ({id, name}) => {
        const h=id+'/'+name;
        const m_api = api();
        console.log(`getContent: getting '${h}'`);
        return m_api
        .get(h)
        .then(response => {
            const prefix = `${id}\/`;
            console.log(`equipping pterodactyls with '${prefix}'`); 
            return new Promise(resolve => {
                console.log('getContent: got response data ');
                const ret = fixUrls.prefixRelativeUrls(response.data, prefix);
                resolve({ data:ret });
            });
        });
    }
};


// WEBPACK FOOTER //
// ./src/services/StreamsService.js